module.exports = __webpack_public_path__ + "media/images/icons/flags/MQ-912f8523ca26b03bbfe6ec61b0cdcd3f.svg";